function vacinas(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"As vacinas estão entre as principais formas de prevenir doenças causadas por vírus e bactérias.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
                    {
						"text":"Elas são feitas a partir do microrganismo causador da doença ou seus derivados e sua função é estimular a produção de anticorpos para combater o agente invasor.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
                    },
                    {
						"text":"A partir desse processo, nosso sistema imunológico adquire uma memória que proporcionará uma resposta mais eficiente do organismo em caso de infecção, impedindo que a doença se desenvolva.",
						"title":"Vacinas: o que são e para que servem?",
						"image":"images/games/informs/vacinas/1.png",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/vacinas/1.png"
			}
		]
	};
}

export {vacinas};
